export class Idea {
  id: number;
  title: string;
  description: string;
  authorId: number;
  authorFirstName: string;
  authorLastName: string;
  statusCreatedAt: number;
  imageFileId: string;
  categoryImageFileId: string;
  optionalFileId: string;
  economicalGroundFileId: string;
  statusId: number;
  signerQuantity: number;
  budget: number;
  executionPeriod: number;
  categoryTitle: string;
  categoryId: number;
  categoryKeyword: number;
  metaData: { [key: string]: any };
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/shared/idea.ts